import { render } from "./SearchBar.vue?vue&type=template&id=975e0038&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=975e0038&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-975e0038"

export default script